export const SINGLE_VIEW = "سنجل فيو";
export const SINGLE_VIEW_PLATFORM = "باستخدام منصة سنجل فيو";
export const TABBY = "تـابـي";
export const TABBY_PLATFORM =
  "تمت هذه المعاملة عبر خدمة تابي، لذلك يفضل استخدام تابي لاسترداد المبلغ للمستخدم.";
export const MOYASAR = "ميسر";
export const MOYASAR_PLATFORM =
  "تمت هذه المعاملة عبر منصة ميسر، لذلك يفضل استخدام ميسر لاسترداد المبلغ للمستخدم.";
export const MANUAL = "يـــــدوي";
export const MANUAL_BANK_TRANSFER = "عن طريق تحويل بنكي يدوي";
export const CHOOSE_TRANSFER_METHOD = "اخـتـر طريقة التحويل";
export const CHOOSE_REFUND_METHOD = "اختر طريقة الاسترداد";
export const OTHER_REFUND_METHODS = "طرق استرداد أخرى";
export const SINGLE_VIEW_TRANSER_HEADER = "تحويل عن طريق سنجل فيو";
export const TABBY_TRANSER_HEADER = "إرجاع عن طريق تابي (TABBY)";
export const MOYASAR_TRANSER_HEADER = "إرجاع عن طريق ميسر (MOYASAR)";
export const BANK_TRANSFER_HEADER = "تحويل يدوي";
export const TOTAL_DUE = "إجمالي المستحق";
export const BANK_ACCOUNT_NUMBER = "رقم الحساب البنكي";
export const BENEFICIARY_NAME = "اسم المستفيد";
export const THE_BANK = "البنك";
export const ADDRESS = "العنوان";
export const THE_AMOUNT_TO_BE_TRANSFERED = "المبلغ المراد تحويلة (ريال سعودي)";
export const TRANSFER_TO_REFERENCE_NUMBER = "الرقم المرجعي للتحويل";
export const UNAVAILABLE = "غير متوفر";
export const RIYAL = "ريال";
export const COMPLETE_CONVERSION = "إتمام عملية التحويل";
export const BANK_ACCOUNT_NOT_ADDED =
  "المستخدم لم يقم بإضافة بيانات الحساب البنكي. يُرجى التواصل معه لإدخال هذه المعلومات عبر حسابه الخاص.";
export const CONVERSION_IN_PROGRESS = "جاري تنفيذ عملية التحويل";
export const BANK_SINGLE_VIEW_ISSUE = "مشكلة في التحويل عن طريق سنجل فيو";
export const WAITING_FOR_CONVERSION =
  "بانتظار تأكيد التحويل، يأخذ هذا الإجراء بضع دقائق";
export const SUCCESS_MESSAGE = "تمت عملية التحويل بنجاح";
export const TRANSACTION_DATE = "تاريخ التحويل";
export const AMOUNT_MISMATCH_ERROR =
  "يجب أن يكون المبلغ مساوياً للمبلغ المستحق";
